import {AppConfiguration} from "@/appConfiguration";
import {TrackingStorage} from "@/store/localStorage";

const countEvents: Record<string, number> = {};
const MIXPANEL_TRACK_LIMIT_STORAGE = "memoryExplorer.mixpanelTrackFirst10";

export namespace Tracking {
  interface IEventProps {
    [key: string]: any;
  }

  const sendAnalyticsToSite = (eventName: string, eventProperties?: IEventProps) => {
    window.parent.postMessage(
      JSON.stringify({type: "TRACK", payload: {eventName, eventProperties}}),
      AppConfiguration.iframeParentUrl
    );
  };

  function trackLimited(limit: number, name: string, props?: IEventProps): void {
    const newCount =
      (countEvents[name] || TrackingStorage.getLocalStorageCount(name, MIXPANEL_TRACK_LIMIT_STORAGE)) + 1;
    countEvents[name] = newCount;

    if (newCount <= limit) {
      TrackingStorage.setLocalStorageCount(name, MIXPANEL_TRACK_LIMIT_STORAGE, newCount);
      track(name, props);
    }
  }

  export function trackOnce(name: string, props?: IEventProps): void {
    trackLimited(1, name, props);
  }

  export function track(eventName: string, eventProperties?: IEventProps) {
    sendAnalyticsToSite(eventName, eventProperties);
  }
}
